import {Organisation} from '@eitje/api'
import {useParams} from '@eitje/bridge'
import {DatePickerField, Input} from '@eitje/web_components'
import {LegacyFormModal} from '~/components'
import {goBack} from '~/routing/actions'

export const EditOrganisation = () => {
	const {id} = useParams()
	const organisation = Organisation.useFind(id)

	return (
		<LegacyFormModal
			name="edit_organisation"
			onSubmit={params => organisation.update(params)}
			afterSubmit={goBack}
			modalProps={{okButtonProps: {t: 'common.save'}}}
			width={348}
			initialValues={organisation}
		>
			<Input field="name" required />
			<DatePickerField field="first_billing_date" required />
		</LegacyFormModal>
	)
}
